import { useAppSelector } from 'redux/hooks';

export default function useIsDevMode() {
  const isDevMode = useAppSelector(s => s.app.devMode);

  return isDevMode;
}
